import { WarehouseDocumentViewComponent } from './components/warehouse-document-view/warehouse-document-view.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@common/common.module';
import { WarehouseDocumentsListComponent } from './components/warehouse-documents-list/warehouse-documents-list.component';
import { ViewMode } from '@common/models/view-mode';
import { CanDeactivateView } from '@common/guards/view.deactivate';

export const WAREHOUSE_DOCUMENT_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
    },
    {
        path: 'list',
        component: WarehouseDocumentsListComponent
    },
    {
        path: 'view/:id',
        component: WarehouseDocumentViewComponent,
        data: {
            mode: ViewMode.view
        }
    },
    {
        path: 'edit/:id',
        component: WarehouseDocumentViewComponent,
        data: {
            mode: ViewMode.edit
        },
        canDeactivate: [CanDeactivateView]
    },
    {
        path: 'create',
        component: WarehouseDocumentViewComponent,
        data: {
            mode: ViewMode.create
        },
        canDeactivate: [CanDeactivateView]
    },
    {
        path: '**',
        redirectTo: 'list'
    }
];


@NgModule({
    imports: [CommonModule, RouterModule.forChild(WAREHOUSE_DOCUMENT_ROUTES)],
    declarations: [WarehouseDocumentsListComponent, WarehouseDocumentViewComponent],
    providers: [CanDeactivateView]
})
export class WarehouseDocumentsModule { }
